import { useEffect, useState } from 'react';

// The API reports no progress within a turn, so these only say how long it's been: a step-by-step status here
// would be made up.
const phrases = [
  { after: 0, text: 'Working on it' },
  { after: 8_000, text: 'Still on it' },
  { after: 25_000, text: 'This one is taking a little longer' },
];

/** A reply Finlay is still writing. */
export function PendingReply() {
  const [phrase, setPhrase] = useState(0);

  useEffect(() => {
    const timers = phrases.map(({ after }, index) =>
      setTimeout(() => setPhrase(index), after),
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div
      className="text-muted-foreground flex items-center gap-2.5 text-sm"
      role="status"
    >
      <span aria-hidden className="flex gap-1">
        {[0, 1, 2].map((dot) => (
          <span
            className="bg-primary size-1.5 animate-[chat-typing_1.2s_ease-in-out_infinite] rounded-full opacity-30 motion-reduce:animate-none motion-reduce:opacity-100"
            key={dot}
            style={{ animationDelay: `${dot * 150}ms` }}
          />
        ))}
      </span>
      {/* Keyed so each new phrase settles in out of a slight blur rather than swapping abruptly. */}
      <span
        className="transition-[opacity,filter] duration-200 ease-out starting:opacity-0 starting:blur-[2px]"
        key={phrase}
      >
        {phrases[phrase]?.text}…
      </span>
    </div>
  );
}
